import { USER_STATE } from "core/constants/auth";

const isUserBlocked = userState => userState === USER_STATE.BLOCKED;

export default isUserBlocked;